import React from 'react';

type SwitcherOneProps = {
  enabled: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
  disabled?: boolean;
}

const SwitcherOne: React.FC<SwitcherOneProps> = ({ enabled, handleChange, name, label, disabled = false }) => {
  return (
    <div>
      <label
        htmlFor="toggle1"
        className={`flex select-none items-center ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      >
        <div className="relative">
          <input
            type="checkbox"
            id="toggle1"
            className="sr-only"
            onChange={handleChange}
            name={name}
            checked={enabled}
            disabled={disabled}
          />
          <div className="block h-8 w-14 rounded-full bg-meta-9 dark:bg-[#5A616B]"></div>
          <div
            className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white transition ${
              enabled && '!right-1 !translate-x-full !bg-primary dark:!bg-white'
            }`}
          ></div>
        </div>
        <span className="text-gray-900 dark:text-gray-300 ms-3 text-sm font-medium">
          {label}
        </span>
      </label>
    </div>
  );
};

export default SwitcherOne;
